/**
 * Shared countdown formatting for ceremony surfaces.
 *
 * Previously the HomePage "Tonight" banner and the LivePage UpcomingCeremonyCard
 * each carried their own formatter; the banner's lacked a day-scale branch, so a
 * ceremony weeks away rendered as a raw hour count (e.g. "live in 437h"). This
 * module is the single source of truth so the two surfaces can't drift again.
 */

/** Magnitude of a positive duration as up to two units: "18d 5h", "2h 0m", "12m". */
export function formatDuration(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
}

function isSameLocalDay(aMs: number, bMs: number): boolean {
  return new Date(aMs).toDateString() === new Date(bMs).toDateString();
}

/**
 * Banner-chip label for the next ceremony. Honest about day-scale gaps and about
 * whether the ceremony is actually today, so it never claims "Tonight" for an
 * event that's weeks out. Pass a ticking `nowMs` to keep it live.
 */
export function ceremonyChipLabel(scheduledAtMs: number, nowMs: number): string {
  const diff = scheduledAtMs - nowMs;
  if (diff <= 0) return "live now";
  const prefix = isSameLocalDay(scheduledAtMs, nowMs) ? "Tonight" : "Upcoming";
  return `${prefix} · live in ${formatDuration(diff)}`;
}
